import { render } from "./loader1.vue?vue&type=template&id=74b5cd82"
import script from "./loader1.vue?vue&type=script&lang=js"
export * from "./loader1.vue?vue&type=script&lang=js"

import "./loader1.vue?vue&type=style&index=0&id=74b5cd82&lang=css"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__